// extracted by mini-css-extract-plugin
var _1 = "DocumentEditAccessActionModalFields-moduleaccessField__FE5yV";
export { _1 as "accessField" }
